import { extractLink, extractProvider, extractTitle } from '@atlaskit/link-extractors';
import { extractIcon } from '../common/icon';
import { extractLozenge } from '../common/lozenge';
import { extractTitleTextColor } from '../common/primitives';
import { extractTitlePrefix } from '../common/title-prefix';
import { CONFLUENCE_GENERATOR_ID, JIRA_GENERATOR_ID } from '../constants';
export var extractInlineIcon = function extractInlineIcon(jsonLd) {
  var provider = extractProvider(jsonLd);
  if (provider && provider.id) {
    if (provider.id === CONFLUENCE_GENERATOR_ID || provider.id === JIRA_GENERATOR_ID) {
      return extractIcon(jsonLd);
    }
  }
  return extractIcon(jsonLd, 'provider');
};
export var extractInlineProps = function extractInlineProps(jsonLd, renderers, removeTextHighlightingFromTitle) {
  return {
    link: extractLink(jsonLd),
    title: extractTitle(jsonLd, removeTextHighlightingFromTitle),
    lozenge: extractLozenge(jsonLd),
    icon: extractInlineIcon(jsonLd),
    titleTextColor: extractTitleTextColor(jsonLd),
    titlePrefix: extractTitlePrefix(jsonLd, renderers, 'inline')
  };
};